import { render, staticRenderFns } from "./CustomerListDesktopView.vue?vue&type=template&id=1324b402&"
import script from "./CustomerListDesktopView.vue?vue&type=script&lang=js&"
export * from "./CustomerListDesktopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports